export default __webpack_public_path__ + "static/media/chooseNeutral.a29a941a.png";